import { useEffect } from 'react';
import { Toast } from '@shared/ui/toast/toast';
import toast from 'react-hot-toast';
import { getQueryError } from '@shared/lib/utils/get-query-error/get-query-error';
import {
    CACHE_KEY_SYNC_CRM_INTERESTS,
    CACHE_KEY_SYNC_CRM_PRODUCTS,
} from '@features/product/crm-sync/config/api-constants';
import { useSyncCRMInterestsMutation, useSyncCRMProductsMutation } from '@features/product/crm-sync/api/crm-sync-api';

export const useSyncCRM = () => {
    const [syncCRMInterests, syncCRMInterestsResult] = useSyncCRMInterestsMutation({
        fixedCacheKey: CACHE_KEY_SYNC_CRM_INTERESTS,
    });
    const [syncCRMProducts, syncCRMProductsResult] = useSyncCRMProductsMutation({
        fixedCacheKey: CACHE_KEY_SYNC_CRM_PRODUCTS,
    });

    const handleSyncCRM = () => {
        return Promise.allSettled([syncCRMInterests(), syncCRMProducts()]);
    };

    useEffect(() => {
        if (syncCRMInterestsResult.isSuccess) {
            toast.custom((t) => {
                return (
                    <Toast
                        type='success'
                        title='Успешно!'
                        description={`Продукты интереса синхронизированы.\nОбновленно продуктов интереса: ${syncCRMInterestsResult.data.updatedCount}`}
                        onClose={() => {
                            toast.remove(t.id);
                        }}
                    />
                );
            });
            syncCRMInterestsResult.reset();
        } else if (syncCRMInterestsResult.isError) {
            toast.custom((t) => {
                return (
                    <Toast
                        type='error'
                        title='Ошибка!'
                        description={`Не удалось синхронизировать продукты интереса.\n${getQueryError(syncCRMInterestsResult)?.message}`}
                        onClose={() => {
                            toast.remove(t.id);
                        }}
                    />
                );
            });
            syncCRMInterestsResult.reset();
        }
    }, [syncCRMInterestsResult.isSuccess, syncCRMInterestsResult.isError]);

    useEffect(() => {
        if (syncCRMProductsResult.isSuccess) {
            toast.custom((t) => {
                return (
                    <Toast
                        type='success'
                        title='Успешно!'
                        description={`Продукты синхронизированы.\nОбновленно продуктов: ${syncCRMProductsResult.data.updatedCount}`}
                        onClose={() => {
                            toast.remove(t.id);
                        }}
                    />
                );
            });
            syncCRMProductsResult.reset();
        } else if (syncCRMProductsResult.isError) {
            toast.custom((t) => {
                return (
                    <Toast
                        type='error'
                        title='Ошибка!'
                        description={`Не удалось синхронизировать продукты.\n${getQueryError(syncCRMProductsResult)?.message}`}
                        onClose={() => {
                            toast.remove(t.id);
                        }}
                    />
                );
            });
            syncCRMProductsResult.reset();
        }
    }, [syncCRMProductsResult.isSuccess, syncCRMProductsResult.isError]);

    return {
        handleSyncCRM,
    };
};
